// extracted by mini-css-extract-plugin
module.exports = {"filter":"Filtering_filter__1yvvC","filter_body":"Filtering_filter_body__3y2Wl"};